module.exports = __webpack_public_path__ + "img/wa.5b9ad16b.png";